// React
import React from 'react';

// Styles
import '../styles/IndiceCardPopUp.css';

// Components
import MissionHeader from './MissionHeader';
import MainButton from './MainButton';
import InputNumber from './InputNumber';

// Data
import { indicesDataChapitre1 } from '../assets/data/indicesData.ts';
import { indicesDataChapitre2 } from '../assets/data/indicesData.ts';
import { useParams } from 'react-router-dom';

// Props du composant IndiceCardPopUp
type IndiceCardPopUpProps = {
    setShowIndiceCardPopup: React.Dispatch<React.SetStateAction<boolean>>;
};

const IndiceCardPopUp: React.FC<IndiceCardPopUpProps> = ({ setShowIndiceCardPopup }) => {
    const [cardNumber, setCardNumber] = React.useState<number>(0);
    const [showIndice, setShowIndice] = React.useState<boolean>(false);
    const [indiceText, setIndiceText] = React.useState<string>('');
    const [isIndiceFound, setIsIndiceFound] = React.useState<boolean>(false);

    const { missionNumber } = useParams<{ missionNumber: string }>();

    // Gère le clic sur le bouton Valider
    const handleValiderClick = () => {
        if (isIndiceFound) {
            setIsIndiceFound(false);
        }
        // Sélectionne les données d'indices en fonction du numéro de mission
        const indicesData = missionNumber === '1' ? indicesDataChapitre1 : indicesDataChapitre2;

        // Recherche de l'indice correspondant au numéro de carte
        const found = indicesData.find((indice) => indice.cardNumbers.includes(cardNumber));

        // Met à jour le texte de l'indice ou un message par défaut
        if (found) {
            setIndiceText(found.hint);
            setIsIndiceFound(true);
        } else {
            setIndiceText("Pas d'indice disponible pour ce numéro de carte.");
        }

        setShowIndice(true);
    };

    return (
        <div className='popup indice-card-popup'>
            <div className='indice-card-gradient'></div>
            {showIndice && (
                <div className='indice-content'>
                    <MissionHeader
                        showBackButton={false}
                        showSettingsButton={false}
                        showCloseButton={false}
                        logoVariant='default'
                        closeFunction={() => setShowIndiceCardPopup(false)}
                        closeButtonVariant='tertiary'
                    />
                    <p className='indice-card-number'>
                        N°<span>{cardNumber}</span>
                    </p>
                    <div className='indice-card-text'>
                        {isIndiceFound && (
                            <img
                                src='./images/idea-icon.png'
                                alt='Idea Icon'
                                className='indice-card-idea-icon'
                            />
                        )}
                        <p
                            dangerouslySetInnerHTML={{
                                __html: indiceText.replace(/\n/g, '<br />') || '',
                            }}
                        />
                    </div>
                    <MainButton
                        text='Fermer'
                        onClick={() => setShowIndiceCardPopup(false)}
                    />
                </div>
            )}
            <MissionHeader
                showBackButton={false}
                showSettingsButton={false}
                showCloseButton={true}
                logoVariant='default'
                closeFunction={() => setShowIndiceCardPopup(false)}
                closeButtonVariant='tertiary'
            />
            <p className='indice-card-popup-text'>
                Saisissez<span>le numéro</span> de la carte pour avoir
                <br />
                <b>un indice</b>
                <img
                    src='./images/idea-icon.png'
                    alt='Idea Icon'
                    className='indice-card-info-icon'
                />
            </p>
            <div className='input-indice-cards-group'>
                <InputNumber
                    setValue={setCardNumber}
                    tensInitialValue={0}
                    onesInitialValue={0}
                    onEnter={handleValiderClick}
                />
            </div>
            <MainButton
                text='Valider'
                onClick={handleValiderClick}
                disabled={cardNumber === 0}
            />
            <div className='indice-card-gradient-2'></div>
        </div>
    );
};

export default IndiceCardPopUp;
